import { connect } from 'react-redux'
import { SignUpCard } from '../components'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import { makePath } from '../../../lib';
import { getWord, WID } from '../../../constants/Language';

const mapStateToProps = (state, ownProps) => {
  const { user } = state.authentication
  const { settings } = state.settings
  const { language } = state.user
  return ({
    user,
    settings,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: (user, history) => {
      if (user) {
        dispatch(api.user.settings((dispatch, response) => {
          if (response.result === true && response.settings && response.settings.userName !== undefined) {
            history.goBack()
          }
        }))
      }
    },
    handleRegister: (userName, displayName, history, language) => () => {
      dispatch(api.user.add({ userName, displayName },
        (dispatch) => {
          dispatch(actions.signUpCard.disabled())
        },
        (dispatch, response) => {
          dispatch(actions.signUpCard.enabled())
          if (response.result === true) {
            history.push(makePath('/', language))
          }
          else if (response.hasSameUserName) {
            dispatch(actions.snackbar.notify(getWord(WID.SIGN_UP_CARD.NOTIFY.MESSAGE_NAME_IS_ALREADY_BEING_USED, language), 'error'))
          }
        }
      ))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignUpCard)


// WEBPACK FOOTER //
// ./src/Pages/SignUp/containers/SignUpCard.js